import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';

function PlanEditorInnerContainer({
    managedInSmp,
    children,
    title,
    flex
}) {
    const classes = useStyles();
    return (
        <div className={clsx(classes.root, !managedInSmp && classes.disabled)}>
            {
                title &&
                    <h1>{title}</h1>
            }
            <div className={flex? classes.flex: null} >
                {children}
            </div>
        </div>
    );
}

const useStyles = makeStyles({
    root: {
        paddingLeft: 20,
        paddingTop: '9px',
    },
    disabled: {
        backgroundColor: 'transparent',
        opacity: '0.6',
        color: '#A7A9AC',
        '& a': {
            textDecoration: 'none',
            cursor: 'default',
            '&:hover': {
                textDecoration: 'none'
            }
        },
    },
    flex:{
        display: 'flex',
        gridGap: '50px'
    }
})

PlanEditorInnerContainer.propTypes = {
    managedInSmp: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired,
    title: PropTypes.node,
}

export default PlanEditorInnerContainer;